import AnnotationSideControls from "./AnnotationSideControls";
import annotationSideControlsReducer from "./store/AnnotationSideControlsSlice";

export { annotationSideControlsReducer };
export default AnnotationSideControls;
